import { useEffect, useState } from "react";
import api, { formatDate, formatTime } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const CLS = {
  confirmed: "bg-[#19C3B3]/15 text-[#0F7A70]",
  completed: "bg-emerald-100 text-emerald-700",
  cancelled: "bg-slate-100 text-slate-500",
};

export default function Bookings() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("upcoming");
  function load() { api.get("/bookings").then((r) => setItems(r.data)); }
  useEffect(() => { load(); }, []);

  const now = new Date();
  const upcoming = items.filter((b) => new Date(b.slot_start) >= now).sort((a,b) => a.slot_start.localeCompare(b.slot_start));
  const past = items.filter((b) => new Date(b.slot_start) < now).sort((a,b) => b.slot_start.localeCompare(a.slot_start));
  const list = tab === "upcoming" ? upcoming : past;

  async function change(b, status) {
    await api.put(`/bookings/${b.id}/status`, { status });
    toast.success("Statut mis à jour");
    load();
  }

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-[#16324F]">Réservations</h1>
      <p className="mt-1 text-slate-500">Vos interventions planifiées.</p>

      <div className="mt-6 inline-flex bg-white border border-slate-200 rounded-full p-1">
        <button onClick={() => setTab("upcoming")} className={`px-4 py-1.5 text-sm font-semibold rounded-full ${tab === "upcoming" ? "bg-[#16324F] text-white" : "text-slate-600"}`} data-testid="tab-upcoming">À venir ({upcoming.length})</button>
        <button onClick={() => setTab("past")} className={`px-4 py-1.5 text-sm font-semibold rounded-full ${tab === "past" ? "bg-[#16324F] text-white" : "text-slate-600"}`} data-testid="tab-past">Passées ({past.length})</button>
      </div>

      <div className="mt-6 grid gap-4">
        {list.length === 0 && <div className="text-slate-400 italic text-sm">Aucune réservation.</div>}
        {list.map((b) => (
          <div key={b.id} className="kf-card p-5 flex flex-col md:flex-row md:items-center gap-4">
            <div className="w-24 text-center md:text-left">
              <div className="text-xs uppercase text-slate-500 font-semibold">{formatDate(b.slot_start)}</div>
              <div className="font-display text-2xl font-extrabold text-[#16324F]">{formatTime(b.slot_start)}</div>
            </div>
            <div className="flex-1">
              <div className="font-semibold text-[#16324F]">{b.customer?.first_name} {b.customer?.last_name}</div>
              <div className="text-sm text-slate-500">Réf. {b.reference} · {b.customer?.phone}</div>
            </div>
            <Badge className={`${CLS[b.status]} border-0 font-semibold`}>{b.status}</Badge>
            <div className="flex gap-2">
              {b.status === "confirmed" && (
                <>
                  <Button size="sm" variant="outline" className="rounded-full" onClick={() => change(b, "completed")} data-testid={`complete-${b.id}`}>Terminer</Button>
                  <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-200 hover:bg-red-50" onClick={() => change(b, "cancelled")} data-testid={`cancel-${b.id}`}>Annuler</Button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
